angular.module('dpw.directives')
    .component('dpwSecondaryNav', {
        bindings: {
            data: '<',
            isPanelVisible: '<'
        },
        templateUrl: 'dpw-secondary-nav.html',
        controller: ['$element', '$timeout', function ($element, $timeout) {
            var self = this;

            self.$onChanges = function (changesObj) {
                var data = _.get(changesObj, 'data.currentValue');

                if (data && data.withProductFilter) {
                    $timeout(function () {
                        self.enableOverlayScrollbar();
                    });
                }
            }

            self.enableOverlayScrollbar = function () {
                var sidebarEl = $element.find('.secondary-nav-sidebar');

                if (_.isFunction(window.OverlayScrollbars) && sidebarEl) {
                    window.OverlayScrollbars(sidebarEl, {
                        scrollbars: {
                            autoHide: 'leave'
                        },
                        overflowBehavior: {
                            x: 'hidden'
                        }
                    });
                }
            };
        }]
    });

